import React, { Component } from "react";
import { Overlay, Popover } from "react-bootstrap";
import api from '../../apiClient/v1';
import * as css from "./logistica.css";

class Logistica extends Component {
    constructor(props) {
        super(props)
        this.state = {
            show: false,
            tiene: this.props.tiene,
            logistica: [],
            enableGet: true,
            editando: false,
        }
    }

    handleClick(e) {
        this.setState({
            target: e.target,
            show: !this.state.show
        });
    }

    handleClose() {
        this.setState({
            show: false
        });
    }

    cancelarEditar() {
        this.setState({
            editando: false,
            input: "",
        });
    }

    updateLogistica(logistica) {
        this.setState({
            logistica: logistica,
            tiene: logistica.length > 0 ? true : false
        })
    }

    traerLogistica(){
        this.setState({
            enableGet: false
        });
        api.logistica.getLogistica(this.props.idLocal)
        .then(resp => {
            this.setState({
                logistica: resp,
                enableGet: true,
            })
        })
        .catch(err => {
            console.log("Error al traer logistica")
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.logistica !== this.props.logistica) {
            this.setState({
                logistica: this.props.logistica,
                tiene: true
            })
        }
    }

    render() {
        let styles = this.state.tiene ? { color: '#337AB7', cursor: 'pointer' } : { color: '#5CB85C' } ;
        return (
            <div style={this.state.show ? { backgroundColor: "#17b485" } : {}}>
                <p onClick={this.handleClick.bind(this)} style={styles}>
                    {this.state.tiene ? <i className="glyphicon glyphicon-info-sign" style={styles}></i> : <i className="glyphicon glyphicon-plus" style={styles}></i>}
                </p>
                <Overlay
                    show={this.state.show}
                    target={this.state.target}
                    placement="right"
                    onHide={this.handleClose.bind(this)}
                    rootClose
                >
                    <Popover
                        id={this.props.idLocal}
                        bsClass={css.logistica_popover + " popover"}
                    >
                        <div className={css.logistica_container}>
                            {this.state.logistica.map((logistica) => {
                                return (
                                    <Log key={logistica.id}
                                        logistica={logistica}
                                        update={this.updateLogistica.bind(this)}
                                        traerLogistica={this.traerLogistica.bind(this)}
                                        idLocal={this.props.idLocal}
                                    />
                                )
                            })}
                        </div>
                        <FormText
                            idLocal={this.props.idLocal}
                            update={this.updateLogistica.bind(this)}
                            getLogistica={this.traerLogistica.bind(this)}
                            enableGet={this.state.enableGet}
                            //traerLogistica={this.traerLogistica.bind(this)}
                        />
                    </Popover>
                </Overlay>
            </div>
        )
    }
}
export default Logistica;

class Log extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            defaulttext: "",
            input: "",
            editando: false,
            enable: true
        }
    }

    handleClick() {
        this.setState({
            editando: true,
            input: this.props.logistica.texto
        })
    }

    handleChangeEditar(e) {
        this.setState({
            input: e.target.value
        });
    }

    cancelarEditar() {
        this.setState({
            editando: false,
            input: "",
        });
    }

    handleSubmit(e) {
        e.preventDefault();
        this.setState({
            enable: false
        });
        api.logistica.editLogistica(this.props.logistica.id, {
            logistica: this.state.input.trim()
        })
            .then(resp => {
                this.props.update(resp);
                this.setState({
                    defaulttext: "",
                    input: "",
                    editando: false,
                    enable: true
                });
            })
            .catch(err => {
                console.log("Error al editar logistica")
            })
    }

    handleDelete(){
        this.setState({
            enable: false
        });
        api.logistica.deleteLogistica(this.props.logistica.id)
            .then(resp => {
                this.props.update(resp);
                this.setState({
                    defaulttext: "",
                    input: "",
                    editando: false,
                    enable: true
                });
            })
            .catch(err => {
                console.log("Error al eliminar logistica")
            })
    }

    render() {
        return (
            <div className={css.logistica_mensaje}>
                <p className={css.nombre + " " + css.textoConTooltip}>
                    {this.props.logistica.usuario + ":"}
                    {<span>
                        {this.props.logistica.fecha + " "}
                        {this.props.logistica.usuario_completo}
                    </span>}
                </p>
                <form onSubmit={this.handleSubmit.bind(this)}>
                {this.props.logistica.editable ?
                        (this.state.editando ?
                            <p>
                                <input className={css.input_logistica_editable} name="logistica" type="text" value={this.state.input} onChange={this.handleChangeEditar.bind(this)} autoFocus required/>
                                <button disabled={!this.state.enable} type="submit" className="btn btn-success btn-xs"><i className="glyphicon glyphicon-ok"></i></button>
                                <button onClick={this.cancelarEditar.bind(this)} type="button" className="btn btn-warning btn-xs"><i className="glyphicon glyphicon-remove"></i></button>
                                <button disabled={!this.state.enable} onClick={this.handleDelete.bind(this)} type="button" className="btn btn-danger btn-xs"><i className="glyphicon glyphicon-trash"></i></button>
                            </p>
                            : <p onClick={this.handleClick.bind(this)} className={css.input_logistica_pointer}>{this.props.logistica.texto}</p>
                        )
                        : <p>{this.props.logistica.texto}</p>
                    }
                </form>
            </div>
        )
    }
}

class FormText extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            idLogistica: 0,
            defaulttext: "",
            textarea: "",
            visible: false,
            rows: 5,
            enable: true
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleCancelar = this.handleCancelar.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        this.setState({
            enable: false
        });
        api.logistica.saveLogistica(this.props.idLocal, {
            idLogistica: this.state.idLogistica,
            logistica: this.state.textarea.trim()
        })
            .then(resp => {
                this.props.update(resp);
                this.setState({
                    defaulttext: "",
                    textarea: "",
                    visible: false,
                    rows: 5,
                    enable: true
                });
            })
            .catch(err => {
                console.log("Error al enviar/recibir logistica")
            })
    }

    handleChange(e) {
        this.setState({
            textarea: e.target.value,
            visible: true
        });
        const currentRows = e.target.scrollHeight / 17;
        if (currentRows <= 5) {
            this.setState({ rows: currentRows });
        }
    }

    handleCancelar() {
        this.setState((state) => ({
            textarea: state.defaulttext,
            visible: false
        }));
    }

    componentDidMount(){
        this.props.getLogistica()
    }

    render() {
        return (
            <div className={css.formulario} >
                <form onSubmit={this.handleSubmit}>
                    <div className={css.mytextarea}>
                        <textarea
                            ref={(text) => this.textArea = text}
                            onChange={this.handleChange}
                            value={this.state.textarea}
                            maxLength={200}
                            rows={this.state.rows}
                            type="text"
                            name="logistica"
                        />
                        <button disabled={!this.props.enableGet} type="button" onClick={this.props.getLogistica} className="btn btn-primary btn-xs"><i className="glyphicon glyphicon-refresh"></i></button>
                    </div>
                    {this.state.visible
                        ? <div className="">
                            <button disabled={!this.state.enable} type="submit" className="btn btn-success btn-xs"><i className="glyphicon glyphicon-ok"></i></button>
                            <button onClick={this.handleCancelar} type="button" className="btn btn-danger btn-xs"><i className="glyphicon glyphicon-remove"></i></button>
                        </div>
                        : null
                    }

                </form>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./frontEnd/inventarios/programacion-semanal/Logistica.jsx